// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-player-notes {
  position: relative;
  z-index: 3;
  width: auto;
  margin-top: 0.25rem;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.28rem;
  text-align: left;
  pointer-events: auto;
}

.cm-player-notes--compact {
  max-width: 100%;
}

.cm-player-notes--right {
  text-align: right;
  justify-content: flex-end;
  align-self: flex-end;
}

.cm-player-notes__icon-btn {
  appearance: none;
  position: relative;
  z-index: 4;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 999px;
  border: 1.5px solid color-mix(in srgb, var(--cm-primary, #0877bc) 70%, #fff);
  background: var(--cm-primary, #0877bc);
  color: #fff;
  display: inline-grid;
  place-items: center;
  cursor: pointer;
  padding: 0;
  flex: 0 0 auto;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  pointer-events: auto;
  box-shadow: 0 2px 8px rgba(2, 8, 23, 0.28);
}

.cm-player-notes__icon-btn svg {
  pointer-events: none;
}

.cm-player-notes__icon-btn:active {
  transform: scale(0.95);
}

.cm-player-notes__icon-btn.has-notes {
  border-color: #fff;
  box-shadow:
    0 0 0 2px color-mix(in srgb, var(--cm-primary, #0877bc) 45%, transparent),
    0 2px 8px rgba(2, 8, 23, 0.28);
}

.cm-player-notes__icon-btn span {
  position: absolute;
  top: -0.28rem;
  right: -0.28rem;
  min-width: 0.95rem;
  height: 0.95rem;
  padding: 0 0.2rem;
  border-radius: 999px;
  background: var(--cm-primary, #0877bc);
  color: #fff;
  font-size: 0.55rem;
  font-weight: 800;
  line-height: 0.95rem;
  text-align: center;
  pointer-events: none;
}

.cm-page--light .cm-player-notes__icon-btn,
.comp-page--light .cm-player-notes__icon-btn {
  background: var(--cm-primary, var(--comp-primary, #0877bc));
  color: #fff;
  border-color: color-mix(in srgb, var(--cm-primary, #0877bc) 40%, #0f172a);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.18);
}

.cm-player-notes__card {
  width: 100%;
  min-width: 0;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--cm-border, rgba(255, 255, 255, 0.1)) 90%, transparent);
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent),
      transparent 48%
    ),
    color-mix(in srgb, var(--cm-glass, rgba(15, 23, 42, 0.72)) 92%, #0b1220);
  padding: 0.55rem 0.6rem 0.6rem;
  box-shadow: 0 8px 24px rgba(2, 8, 23, 0.22);
}

.cm-player-notes__card-top {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.cm-player-notes__avatar,
.cm-note-dialog__avatar {
  flex: 0 0 auto;
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #fff;
  background: linear-gradient(
    145deg,
    color-mix(in srgb, var(--cm-primary, #0877bc) 88%, #fff),
    color-mix(in srgb, var(--cm-primary, #0877bc) 55%, #0f172a)
  );
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);
}

.cm-player-notes__card-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
}

.cm-player-notes__card-meta strong {
  font-size: 0.86rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--cm-text, #f8fafc);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-player-notes__card-meta span {
  font-size: 0.64rem;
  font-weight: 650;
  color: var(--cm-muted, #94a3b8);
}

.cm-player-notes__add {
  appearance: none;
  border: 0;
  background: var(--cm-primary, #0877bc);
  color: #fff;
  border-radius: 999px;
  padding: 0.38rem 0.7rem;
  font-size: 0.68rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  cursor: pointer;
  box-shadow: 0 6px 16px color-mix(in srgb, var(--cm-primary, #0877bc) 35%, transparent);
}

.cm-player-notes__add:active {
  transform: scale(0.97);
}

.cm-player-notes__empty {
  appearance: none;
  width: 100%;
  margin-top: 0.45rem;
  border: 1px dashed color-mix(in srgb, var(--cm-primary, #0877bc) 42%, transparent);
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 8%, transparent);
  color: var(--cm-muted, #94a3b8);
  border-radius: 12px;
  padding: 0.65rem 0.7rem;
  font-size: 0.72rem;
  font-weight: 650;
  line-height: 1.35;
  text-align: left;
  cursor: pointer;
}

.cm-player-notes__list {
  list-style: none;
  margin: 0.45rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.cm-player-notes__list li {
  position: relative;
  padding: 0.5rem 0.55rem;
  border-radius: 12px;
  border: 1px solid var(--cm-border, rgba(255, 255, 255, 0.08));
  background: rgba(2, 8, 23, 0.32);
  text-align: left;
}

.cm-player-notes__list li.is-note {
  border-color: color-mix(in srgb, #c4b5fd 40%, transparent);
  background: color-mix(in srgb, #8b5cf6 12%, transparent);
}

.cm-player-notes__list li.is-feedback {
  border-color: color-mix(in srgb, var(--cm-primary, #0877bc) 40%, transparent);
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent);
}

.cm-player-notes__item-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.35rem;
  margin-bottom: 0.25rem;
}

.cm-player-notes__badge {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.28rem;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--cm-muted, #94a3b8);
}

.cm-player-notes__badge em {
  font-style: normal;
  padding: 0.08rem 0.35rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: var(--cm-text, #f8fafc);
  letter-spacing: 0.02em;
}

.cm-player-notes__list p {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 650;
  line-height: 1.4;
  color: var(--cm-text, #f8fafc);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.cm-player-notes__empty-media {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  opacity: 0.75;
}

.cm-player-notes__media {
  display: block;
  width: 100%;
  max-height: 180px;
  border-radius: 10px;
  background: #000;
  margin: 0.2rem 0 0.35rem;
  object-fit: cover;
}

.cm-player-notes__media-audio {
  width: 100%;
  margin: 0.15rem 0 0.3rem;
  height: 2.2rem;
}

.cm-player-notes__del {
  appearance: none;
  border: 0;
  background: rgba(255, 255, 255, 0.06);
  color: var(--cm-muted, #94a3b8);
  cursor: pointer;
  padding: 0.28rem;
  border-radius: 8px;
  flex: 0 0 auto;
}

/* —— Compose dialog (portal) —— */
.cm-note-dialog {
  position: fixed;
  inset: 0;
  z-index: 40000;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0;
  width: 100%;
  height: 100%;
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, rgba(2, 8, 23, 0.62));
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  animation: cm-note-fade 0.22s ease;
  overflow: hidden;
  pointer-events: auto;
}

.cm-page .cm-note-dialog {
  position: absolute;
}

.cm-note-dialog__sheet {
  width: 100%;
  max-width: none;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background:
    radial-gradient(
      120% 80% at 10% 0%,
      color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent),
      transparent 58%
    ),
    color-mix(in srgb, var(--cm-note-primary, #0877bc) 16%, #0c111c);
  color: var(--cm-note-text, #f8fafc);
  font-family: var(--brand-font, inherit);
  box-shadow: none;
  padding: calc(0.5rem + env(safe-area-inset-top, 0)) 1rem calc(0.85rem + env(safe-area-inset-bottom, 0));
  animation: cm-note-rise 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  overflow: hidden;
  box-sizing: border-box;
}

.cm-note-dialog__grab {
  width: 2.4rem;
  height: 0.28rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
  margin: 0.25rem auto 0.55rem;
}

.cm-note-dialog__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.6rem;
  margin-bottom: 0.75rem;
}

.cm-note-dialog__head-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
}

.cm-note-dialog__media-play {
  appearance: none;
  border: 1px solid color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 14%, transparent);
  color: var(--cm-note-primary, #0877bc);
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  cursor: pointer;
  position: relative;
  padding: 0;
}

.cm-note-dialog__media-play span {
  position: absolute;
  top: -0.2rem;
  right: -0.2rem;
  min-width: 0.95rem;
  height: 0.95rem;
  padding: 0 0.2rem;
  border-radius: 999px;
  background: var(--cm-note-primary, #0877bc);
  color: #fff;
  font-size: 0.58rem;
  font-weight: 800;
  line-height: 0.95rem;
  text-align: center;
}

.cm-note-dialog__who {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  min-width: 0;
  flex: 1 1 auto;
}

.cm-note-dialog__who.has-matchup {
  align-items: flex-start;
}

.cm-note-dialog__kicker {
  margin: 0;
  font-size: 0.65rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cm-note-muted, #94a3b8);
}

.cm-note-dialog__who h2 {
  margin: 0.12rem 0 0;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  min-width: 0;
}

.cm-note-dialog__side {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  min-width: 0;
}

.cm-note-dialog__player {
  display: flex;
  flex-direction: column;
  gap: 0.04rem;
  min-width: 0;
}

.cm-note-dialog__player strong {
  display: block;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-note-dialog__rating,
.cm-note-dialog__team {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--cm-note-muted, #94a3b8);
}

.cm-note-dialog__vs {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--cm-note-muted, #94a3b8);
}

.cm-note-dialog__close {
  appearance: none;
  border: 0;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  display: grid;
  place-items: center;
  cursor: pointer;
}

.cm-note-dialog__kinds,
.cm-note-dialog__modes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.4rem;
  margin-bottom: 0.45rem;
}

.cm-note-dialog__kinds:has(button:only-child) {
  grid-template-columns: 1fr;
}

.cm-note-dialog__modes {
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 0.65rem;
}

.cm-note-dialog__existing {
  list-style: none;
  margin: 0 0 0.65rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  max-height: 8.5rem;
  overflow: auto;
}

.cm-note-dialog__existing li {
  padding: 0.45rem 0.55rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.22);
}

.cm-note-dialog__existing li.is-note {
  border-color: color-mix(in srgb, var(--cm-note-secondary, #8b5cf6) 40%, transparent);
  background: color-mix(in srgb, var(--cm-note-secondary, #8b5cf6) 12%, transparent);
}

.cm-note-dialog__existing li.is-feedback {
  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 40%, transparent);
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 14%, transparent);
}

.cm-note-dialog__existing-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  margin-bottom: 0.2rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--cm-note-muted, #94a3b8);
}

.cm-note-dialog__existing-head button {
  appearance: none;
  border: 0;
  background: transparent;
  color: #94a3b8;
  padding: 0.15rem;
  cursor: pointer;
}

.cm-note-dialog__existing p {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.35;
  white-space: pre-wrap;
}

.cm-note-dialog__existing video,
.cm-note-dialog__existing audio {
  width: 100%;
  max-height: 120px;
  margin: 0.2rem 0;
  border-radius: 8px;
}

.cm-note-dialog__kinds button,
.cm-note-dialog__modes button {
  appearance: none;
  border: 1px solid color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent);
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 8%, transparent);
  color: var(--cm-note-muted, #94a3b8);
  border-radius: 12px;
  padding: 0.55rem 0.4rem;
  font-size: 0.74rem;
  font-weight: 750;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  cursor: pointer;
}

.cm-note-dialog__kinds button.is-on,
.cm-note-dialog__modes button.is-on {
  color: #fff;
  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 65%, transparent);
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);
}

.cm-note-dialog__hint {
  margin: 0 0 0.65rem;
  font-size: 0.7rem;
  line-height: 1.4;
  color: var(--cm-note-muted, #94a3b8);
}

.cm-note-dialog__body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.cm-note-dialog__body textarea {
  width: 100%;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent);
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 8%, rgba(0, 0, 0, 0.28));
  color: inherit;
  padding: 0.75rem 0.85rem;
  font: inherit;
  font-size: 0.95rem;
  line-height: 1.4;
  resize: vertical;
  min-height: 6rem;
}

.cm-note-dialog__dictate {
  margin-top: 0.55rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 700;
}

.cm-note-dialog__media {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.cm-note-dialog__stage {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: #020617;
  min-height: 180px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.cm-note-dialog__stage--audio {
  min-height: 140px;
  padding: 1rem;
}

.cm-note-dialog__live,
.cm-note-dialog__playback {
  width: 100%;
  max-height: 240px;
  display: block;
  background: #000;
  object-fit: cover;
}

.cm-note-dialog__stage-hint {
  position: absolute;
  inset: auto 0.75rem 0.75rem;
  margin: 0;
  text-align: center;
  font-size: 0.72rem;
  line-height: 1.35;
  color: #cbd5e1;
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.6);
  pointer-events: none;
}

.cm-note-dialog__stage--audio .cm-note-dialog__stage-hint {
  position: static;
  text-shadow: none;
  color: #94a3b8;
  margin-top: 0.65rem;
}

.cm-note-dialog__wave {
  display: flex;
  align-items: flex-end;
  gap: 0.28rem;
  height: 2.4rem;
}

.cm-note-dialog__wave i {
  display: block;
  width: 0.28rem;
  height: 0.55rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 70%, #fff);
  opacity: 0.45;
}

.cm-note-dialog__wave.is-live i {
  opacity: 1;
  animation: cm-note-wave 0.9s ease-in-out infinite;
}

.cm-note-dialog__wave.is-live i:nth-child(2) {
  animation-delay: 0.1s;
}
.cm-note-dialog__wave.is-live i:nth-child(3) {
  animation-delay: 0.2s;
}
.cm-note-dialog__wave.is-live i:nth-child(4) {
  animation-delay: 0.15s;
}
.cm-note-dialog__wave.is-live i:nth-child(5) {
  animation-delay: 0.05s;
}

.cm-note-dialog__rec-bar {
  display: flex;
  gap: 0.45rem;
}

.cm-note-dialog__rec,
.cm-note-dialog__pick {
  appearance: none;
  border: 0;
  border-radius: 999px;
  padding: 0.65rem 0.9rem;
  font-size: 0.78rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  cursor: pointer;
}

.cm-note-dialog__rec {
  flex: 1 1;
  background: var(--cm-note-primary, #0877bc);
  color: #fff;
}

.cm-note-dialog__rec.is-stop {
  background: #e11d48;
}

.cm-note-dialog__pick {
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.cm-note-dialog__media textarea {
  min-height: 3.4rem;
}

.cm-note-dialog__err {
  margin: 0.45rem 0 0;
  font-size: 0.74rem;
  color: #fb7185;
}

.cm-note-dialog__foot {
  margin-top: 0.75rem;
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 0.5rem;
}

.cm-note-dialog__cancel,
.cm-note-dialog__save {
  appearance: none;
  border: 0;
  border-radius: 14px;
  padding: 0.85rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 800;
  cursor: pointer;
}

.cm-note-dialog__cancel {
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
}

.cm-note-dialog__save {
  background: var(--cm-note-primary, #0877bc);
  color: #fff;
  box-shadow: 0 10px 24px color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);
}

.cm-note-dialog__save:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

@keyframes cm-note-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes cm-note-rise {
  from {
    transform: translateY(18%);
    opacity: 0.6;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes cm-note-wave {
  0%,
  100% {
    height: 0.45rem;
  }
  50% {
    height: 1.6rem;
  }
}

@media (min-width: 720px) {
  .cm-note-dialog {
    align-items: center;
    padding: 1.5rem;
  }

  .cm-note-dialog__sheet {
    width: min(100%, 440px);
    height: auto;
    max-height: min(86vh, 680px);
    border-radius: 22px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.4);
  }

  .cm-note-dialog__grab {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cm-note-dialog,
  .cm-note-dialog__sheet,
  .cm-note-dialog__wave.is-live i {
    animation: none;
  }
}

.cm-page--light .cm-player-notes__card {
  background:
    linear-gradient(
      165deg,
      color-mix(in srgb, var(--cm-primary, #0877bc) 10%, transparent),
      transparent 50%
    ),
    rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}

.cm-page--light .cm-player-notes__card-meta strong,
.cm-page--light .cm-player-notes__list p {
  color: #0f172a;
}

.cm-page--light .cm-player-notes__list li {
  background: rgba(255, 255, 255, 0.82);
}

.cm-page--light .cm-player-notes__empty {
  color: #475569;
}

.cm-note-dialog.is-light {
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 18%, rgba(15, 23, 42, 0.28));
}

.cm-note-dialog.is-light .cm-note-dialog__sheet {
  background:
    radial-gradient(
      120% 80% at 10% 0%,
      color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent),
      transparent 58%
    ),
    var(--cm-note-surface, var(--cm-note-bg, #f8fafc));
  color: var(--cm-note-text, #0f172a);
}

.cm-note-dialog.is-light .cm-note-dialog__kicker,
.cm-note-dialog.is-light .cm-note-dialog__hint,
.cm-note-dialog.is-light .cm-note-dialog__existing-head,
.cm-note-dialog.is-light .cm-note-dialog__dictate {
  color: var(--cm-note-muted, #475569);
}

.cm-note-dialog.is-light .cm-note-dialog__who h2,
.cm-note-dialog.is-light .cm-note-dialog__player strong {
  color: var(--cm-note-text, #0f172a);
}

.cm-note-dialog.is-light .cm-note-dialog__rating,
.cm-note-dialog.is-light .cm-note-dialog__team,
.cm-note-dialog.is-light .cm-note-dialog__vs {
  color: var(--cm-note-muted, #475569);
}

.cm-note-dialog.is-light .cm-note-dialog__close,
.cm-note-dialog.is-light .cm-note-dialog__media-play,
.cm-note-dialog.is-light .cm-note-dialog__cancel,
.cm-note-dialog.is-light .cm-note-dialog__pick {
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 10%, transparent);
  color: var(--cm-note-text, #0f172a);
  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent);
}

.cm-note-dialog.is-light .cm-note-dialog__kinds button,
.cm-note-dialog.is-light .cm-note-dialog__modes button {
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 7%, var(--cm-note-surface, #fff));
  color: var(--cm-note-muted, #475569);
  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent);
}

.cm-note-dialog.is-light .cm-note-dialog__kinds button.is-on,
.cm-note-dialog.is-light .cm-note-dialog__modes button.is-on {
  color: #fff;
  background: var(--cm-note-primary, #0877bc);
  border-color: var(--cm-note-primary, #0877bc);
}

.cm-note-dialog.is-light .cm-note-dialog__existing li {
  background: var(--cm-note-surface, #fff);
  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 18%, transparent);
}

.cm-note-dialog.is-light .cm-note-dialog__existing p {
  color: var(--cm-note-text, #0f172a);
}

.cm-note-dialog.is-light .cm-note-dialog__body textarea {
  background: var(--cm-note-surface, #fff);
  color: var(--cm-note-text, #0f172a);
  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent);
}

.cm-note-dialog.is-light .cm-note-dialog__grab {
  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/championship/ChampionshipPlayerNotes.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,4EAA4E;EAC5E,sCAAsC;EACtC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,cAAc;EACd,wCAAwC;EACxC,0BAA0B;EAC1B,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB;;kCAEgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,2DAA2D;EAC3D,WAAW;EACX,yEAAyE;EACzE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iGAAiG;EACjG;;;;;;4EAM0E;EAC1E,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX;;;;GAIC;EACD,mDAAmD;AACrD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sCAAsC;EACtC,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sFAAsF;AACxF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kFAAkF;EAClF,0EAA0E;EAC1E,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,wDAAwD;AAC1D;;AAEA;EACE,6EAA6E;EAC7E,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yFAAyF;EACzF,0BAA0B;EAC1B,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB;;;;;;oEAMkE;EAClE,mCAAmC;EACnC,uCAAuC;EACvC,gBAAgB;EAChB,uGAAuG;EACvG,4DAA4D;EAC5D,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sFAAsF;EACtF,gFAAgF;EAChF,sCAAsC;EACtC,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,oFAAoF;EACpF,kFAAkF;AACpF;;AAEA;EACE,kFAAkF;EAClF,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,sFAAsF;EACtF,+EAA+E;EAC/E,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kFAAkF;EAClF,gFAAgF;EAChF,gGAAgG;AAClG;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,sFAAsF;EACtF,uFAAuF;EACvF,cAAc;EACd,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,yEAAyE;EACzE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,4FAA4F;AAC9F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE;;;;;;6BAM2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE;;;;;;sDAMoD;EACpD,mCAAmC;AACrC;;AAEA;;;;EAIE,oCAAoC;AACtC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;;;EAIE,gFAAgF;EAChF,mCAAmC;EACnC,kFAAkF;AACpF;;AAEA;;EAEE,gGAAgG;EAChG,oCAAoC;EACpC,kFAAkF;AACpF;;AAEA;;EAEE,WAAW;EACX,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,kFAAkF;AACpF;;AAEA;EACE,gFAAgF;AAClF","sourcesContent":[".cm-player-notes {\n  position: relative;\n  z-index: 3;\n  width: auto;\n  margin-top: 0.25rem;\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.28rem;\n  text-align: left;\n  pointer-events: auto;\n}\n\n.cm-player-notes--compact {\n  max-width: 100%;\n}\n\n.cm-player-notes--right {\n  text-align: right;\n  justify-content: flex-end;\n  align-self: flex-end;\n}\n\n.cm-player-notes__icon-btn {\n  appearance: none;\n  position: relative;\n  z-index: 4;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 999px;\n  border: 1.5px solid color-mix(in srgb, var(--cm-primary, #0877bc) 70%, #fff);\n  background: var(--cm-primary, #0877bc);\n  color: #fff;\n  display: inline-grid;\n  place-items: center;\n  cursor: pointer;\n  padding: 0;\n  flex: 0 0 auto;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  pointer-events: auto;\n  box-shadow: 0 2px 8px rgba(2, 8, 23, 0.28);\n}\n\n.cm-player-notes__icon-btn svg {\n  pointer-events: none;\n}\n\n.cm-player-notes__icon-btn:active {\n  transform: scale(0.95);\n}\n\n.cm-player-notes__icon-btn.has-notes {\n  border-color: #fff;\n  box-shadow:\n    0 0 0 2px color-mix(in srgb, var(--cm-primary, #0877bc) 45%, transparent),\n    0 2px 8px rgba(2, 8, 23, 0.28);\n}\n\n.cm-player-notes__icon-btn span {\n  position: absolute;\n  top: -0.28rem;\n  right: -0.28rem;\n  min-width: 0.95rem;\n  height: 0.95rem;\n  padding: 0 0.2rem;\n  border-radius: 999px;\n  background: var(--cm-primary, #0877bc);\n  color: #fff;\n  font-size: 0.55rem;\n  font-weight: 800;\n  line-height: 0.95rem;\n  text-align: center;\n  pointer-events: none;\n}\n\n.cm-page--light .cm-player-notes__icon-btn,\n.comp-page--light .cm-player-notes__icon-btn {\n  background: var(--cm-primary, var(--comp-primary, #0877bc));\n  color: #fff;\n  border-color: color-mix(in srgb, var(--cm-primary, #0877bc) 40%, #0f172a);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.18);\n}\n\n.cm-player-notes__card {\n  width: 100%;\n  min-width: 0;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--cm-border, rgba(255, 255, 255, 0.1)) 90%, transparent);\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent),\n      transparent 48%\n    ),\n    color-mix(in srgb, var(--cm-glass, rgba(15, 23, 42, 0.72)) 92%, #0b1220);\n  padding: 0.55rem 0.6rem 0.6rem;\n  box-shadow: 0 8px 24px rgba(2, 8, 23, 0.22);\n}\n\n.cm-player-notes__card-top {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cm-player-notes__avatar,\n.cm-note-dialog__avatar {\n  flex: 0 0 auto;\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #fff;\n  background: linear-gradient(\n    145deg,\n    color-mix(in srgb, var(--cm-primary, #0877bc) 88%, #fff),\n    color-mix(in srgb, var(--cm-primary, #0877bc) 55%, #0f172a)\n  );\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);\n}\n\n.cm-player-notes__card-meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.05rem;\n}\n\n.cm-player-notes__card-meta strong {\n  font-size: 0.86rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: var(--cm-text, #f8fafc);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-player-notes__card-meta span {\n  font-size: 0.64rem;\n  font-weight: 650;\n  color: var(--cm-muted, #94a3b8);\n}\n\n.cm-player-notes__add {\n  appearance: none;\n  border: 0;\n  background: var(--cm-primary, #0877bc);\n  color: #fff;\n  border-radius: 999px;\n  padding: 0.38rem 0.7rem;\n  font-size: 0.68rem;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  cursor: pointer;\n  box-shadow: 0 6px 16px color-mix(in srgb, var(--cm-primary, #0877bc) 35%, transparent);\n}\n\n.cm-player-notes__add:active {\n  transform: scale(0.97);\n}\n\n.cm-player-notes__empty {\n  appearance: none;\n  width: 100%;\n  margin-top: 0.45rem;\n  border: 1px dashed color-mix(in srgb, var(--cm-primary, #0877bc) 42%, transparent);\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 8%, transparent);\n  color: var(--cm-muted, #94a3b8);\n  border-radius: 12px;\n  padding: 0.65rem 0.7rem;\n  font-size: 0.72rem;\n  font-weight: 650;\n  line-height: 1.35;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cm-player-notes__list {\n  list-style: none;\n  margin: 0.45rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.cm-player-notes__list li {\n  position: relative;\n  padding: 0.5rem 0.55rem;\n  border-radius: 12px;\n  border: 1px solid var(--cm-border, rgba(255, 255, 255, 0.08));\n  background: rgba(2, 8, 23, 0.32);\n  text-align: left;\n}\n\n.cm-player-notes__list li.is-note {\n  border-color: color-mix(in srgb, #c4b5fd 40%, transparent);\n  background: color-mix(in srgb, #8b5cf6 12%, transparent);\n}\n\n.cm-player-notes__list li.is-feedback {\n  border-color: color-mix(in srgb, var(--cm-primary, #0877bc) 40%, transparent);\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent);\n}\n\n.cm-player-notes__item-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.35rem;\n  margin-bottom: 0.25rem;\n}\n\n.cm-player-notes__badge {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.28rem;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--cm-muted, #94a3b8);\n}\n\n.cm-player-notes__badge em {\n  font-style: normal;\n  padding: 0.08rem 0.35rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--cm-text, #f8fafc);\n  letter-spacing: 0.02em;\n}\n\n.cm-player-notes__list p {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 650;\n  line-height: 1.4;\n  color: var(--cm-text, #f8fafc);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.cm-player-notes__empty-media {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  opacity: 0.75;\n}\n\n.cm-player-notes__media {\n  display: block;\n  width: 100%;\n  max-height: 180px;\n  border-radius: 10px;\n  background: #000;\n  margin: 0.2rem 0 0.35rem;\n  object-fit: cover;\n}\n\n.cm-player-notes__media-audio {\n  width: 100%;\n  margin: 0.15rem 0 0.3rem;\n  height: 2.2rem;\n}\n\n.cm-player-notes__del {\n  appearance: none;\n  border: 0;\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--cm-muted, #94a3b8);\n  cursor: pointer;\n  padding: 0.28rem;\n  border-radius: 8px;\n  flex: 0 0 auto;\n}\n\n/* —— Compose dialog (portal) —— */\n.cm-note-dialog {\n  position: fixed;\n  inset: 0;\n  z-index: 40000;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, rgba(2, 8, 23, 0.62));\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  animation: cm-note-fade 0.22s ease;\n  overflow: hidden;\n  pointer-events: auto;\n}\n\n.cm-page .cm-note-dialog {\n  position: absolute;\n}\n\n.cm-note-dialog__sheet {\n  width: 100%;\n  max-width: none;\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0;\n  background:\n    radial-gradient(\n      120% 80% at 10% 0%,\n      color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent),\n      transparent 58%\n    ),\n    color-mix(in srgb, var(--cm-note-primary, #0877bc) 16%, #0c111c);\n  color: var(--cm-note-text, #f8fafc);\n  font-family: var(--brand-font, inherit);\n  box-shadow: none;\n  padding: calc(0.5rem + env(safe-area-inset-top, 0)) 1rem calc(0.85rem + env(safe-area-inset-bottom, 0));\n  animation: cm-note-rise 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.cm-note-dialog__grab {\n  width: 2.4rem;\n  height: 0.28rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.22);\n  margin: 0.25rem auto 0.55rem;\n}\n\n.cm-note-dialog__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.6rem;\n  margin-bottom: 0.75rem;\n}\n\n.cm-note-dialog__head-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex: 0 0 auto;\n}\n\n.cm-note-dialog__media-play {\n  appearance: none;\n  border: 1px solid color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 14%, transparent);\n  color: var(--cm-note-primary, #0877bc);\n  width: 2.1rem;\n  height: 2.1rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.15rem;\n  cursor: pointer;\n  position: relative;\n  padding: 0;\n}\n\n.cm-note-dialog__media-play span {\n  position: absolute;\n  top: -0.2rem;\n  right: -0.2rem;\n  min-width: 0.95rem;\n  height: 0.95rem;\n  padding: 0 0.2rem;\n  border-radius: 999px;\n  background: var(--cm-note-primary, #0877bc);\n  color: #fff;\n  font-size: 0.58rem;\n  font-weight: 800;\n  line-height: 0.95rem;\n  text-align: center;\n}\n\n.cm-note-dialog__who {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.cm-note-dialog__who.has-matchup {\n  align-items: flex-start;\n}\n\n.cm-note-dialog__kicker {\n  margin: 0;\n  font-size: 0.65rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--cm-note-muted, #94a3b8);\n}\n\n.cm-note-dialog__who h2 {\n  margin: 0.12rem 0 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n  display: flex;\n  flex-direction: column;\n  gap: 0.18rem;\n  min-width: 0;\n}\n\n.cm-note-dialog__side {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  min-width: 0;\n}\n\n.cm-note-dialog__player {\n  display: flex;\n  flex-direction: column;\n  gap: 0.04rem;\n  min-width: 0;\n}\n\n.cm-note-dialog__player strong {\n  display: block;\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-note-dialog__rating,\n.cm-note-dialog__team {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--cm-note-muted, #94a3b8);\n}\n\n.cm-note-dialog__vs {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--cm-note-muted, #94a3b8);\n}\n\n.cm-note-dialog__close {\n  appearance: none;\n  border: 0;\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n\n.cm-note-dialog__kinds,\n.cm-note-dialog__modes {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.4rem;\n  margin-bottom: 0.45rem;\n}\n\n.cm-note-dialog__kinds:has(button:only-child) {\n  grid-template-columns: 1fr;\n}\n\n.cm-note-dialog__modes {\n  grid-template-columns: repeat(3, 1fr);\n  margin-bottom: 0.65rem;\n}\n\n.cm-note-dialog__existing {\n  list-style: none;\n  margin: 0 0 0.65rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  max-height: 8.5rem;\n  overflow: auto;\n}\n\n.cm-note-dialog__existing li {\n  padding: 0.45rem 0.55rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.cm-note-dialog__existing li.is-note {\n  border-color: color-mix(in srgb, var(--cm-note-secondary, #8b5cf6) 40%, transparent);\n  background: color-mix(in srgb, var(--cm-note-secondary, #8b5cf6) 12%, transparent);\n}\n\n.cm-note-dialog__existing li.is-feedback {\n  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 40%, transparent);\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 14%, transparent);\n}\n\n.cm-note-dialog__existing-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.35rem;\n  margin-bottom: 0.2rem;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--cm-note-muted, #94a3b8);\n}\n\n.cm-note-dialog__existing-head button {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  padding: 0.15rem;\n  cursor: pointer;\n}\n\n.cm-note-dialog__existing p {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  white-space: pre-wrap;\n}\n\n.cm-note-dialog__existing video,\n.cm-note-dialog__existing audio {\n  width: 100%;\n  max-height: 120px;\n  margin: 0.2rem 0;\n  border-radius: 8px;\n}\n\n.cm-note-dialog__kinds button,\n.cm-note-dialog__modes button {\n  appearance: none;\n  border: 1px solid color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent);\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 8%, transparent);\n  color: var(--cm-note-muted, #94a3b8);\n  border-radius: 12px;\n  padding: 0.55rem 0.4rem;\n  font-size: 0.74rem;\n  font-weight: 750;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  cursor: pointer;\n}\n\n.cm-note-dialog__kinds button.is-on,\n.cm-note-dialog__modes button.is-on {\n  color: #fff;\n  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 65%, transparent);\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);\n}\n\n.cm-note-dialog__hint {\n  margin: 0 0 0.65rem;\n  font-size: 0.7rem;\n  line-height: 1.4;\n  color: var(--cm-note-muted, #94a3b8);\n}\n\n.cm-note-dialog__body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cm-note-dialog__body textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent);\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 8%, rgba(0, 0, 0, 0.28));\n  color: inherit;\n  padding: 0.75rem 0.85rem;\n  font: inherit;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  resize: vertical;\n  min-height: 6rem;\n}\n\n.cm-note-dialog__dictate {\n  margin-top: 0.55rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  color: #94a3b8;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.cm-note-dialog__media {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.cm-note-dialog__stage {\n  position: relative;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #020617;\n  min-height: 180px;\n  display: grid;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.cm-note-dialog__stage--audio {\n  min-height: 140px;\n  padding: 1rem;\n}\n\n.cm-note-dialog__live,\n.cm-note-dialog__playback {\n  width: 100%;\n  max-height: 240px;\n  display: block;\n  background: #000;\n  object-fit: cover;\n}\n\n.cm-note-dialog__stage-hint {\n  position: absolute;\n  inset: auto 0.75rem 0.75rem;\n  margin: 0;\n  text-align: center;\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: #cbd5e1;\n  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.6);\n  pointer-events: none;\n}\n\n.cm-note-dialog__stage--audio .cm-note-dialog__stage-hint {\n  position: static;\n  text-shadow: none;\n  color: #94a3b8;\n  margin-top: 0.65rem;\n}\n\n.cm-note-dialog__wave {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.28rem;\n  height: 2.4rem;\n}\n\n.cm-note-dialog__wave i {\n  display: block;\n  width: 0.28rem;\n  height: 0.55rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 70%, #fff);\n  opacity: 0.45;\n}\n\n.cm-note-dialog__wave.is-live i {\n  opacity: 1;\n  animation: cm-note-wave 0.9s ease-in-out infinite;\n}\n\n.cm-note-dialog__wave.is-live i:nth-child(2) {\n  animation-delay: 0.1s;\n}\n.cm-note-dialog__wave.is-live i:nth-child(3) {\n  animation-delay: 0.2s;\n}\n.cm-note-dialog__wave.is-live i:nth-child(4) {\n  animation-delay: 0.15s;\n}\n.cm-note-dialog__wave.is-live i:nth-child(5) {\n  animation-delay: 0.05s;\n}\n\n.cm-note-dialog__rec-bar {\n  display: flex;\n  gap: 0.45rem;\n}\n\n.cm-note-dialog__rec,\n.cm-note-dialog__pick {\n  appearance: none;\n  border: 0;\n  border-radius: 999px;\n  padding: 0.65rem 0.9rem;\n  font-size: 0.78rem;\n  font-weight: 800;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  cursor: pointer;\n}\n\n.cm-note-dialog__rec {\n  flex: 1;\n  background: var(--cm-note-primary, #0877bc);\n  color: #fff;\n}\n\n.cm-note-dialog__rec.is-stop {\n  background: #e11d48;\n}\n\n.cm-note-dialog__pick {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.cm-note-dialog__media textarea {\n  min-height: 3.4rem;\n}\n\n.cm-note-dialog__err {\n  margin: 0.45rem 0 0;\n  font-size: 0.74rem;\n  color: #fb7185;\n}\n\n.cm-note-dialog__foot {\n  margin-top: 0.75rem;\n  display: grid;\n  grid-template-columns: 1fr 1.4fr;\n  gap: 0.5rem;\n}\n\n.cm-note-dialog__cancel,\n.cm-note-dialog__save {\n  appearance: none;\n  border: 0;\n  border-radius: 14px;\n  padding: 0.85rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.cm-note-dialog__cancel {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n}\n\n.cm-note-dialog__save {\n  background: var(--cm-note-primary, #0877bc);\n  color: #fff;\n  box-shadow: 0 10px 24px color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);\n}\n\n.cm-note-dialog__save:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n@keyframes cm-note-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes cm-note-rise {\n  from {\n    transform: translateY(18%);\n    opacity: 0.6;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes cm-note-wave {\n  0%,\n  100% {\n    height: 0.45rem;\n  }\n  50% {\n    height: 1.6rem;\n  }\n}\n\n@media (min-width: 720px) {\n  .cm-note-dialog {\n    align-items: center;\n    padding: 1.5rem;\n  }\n\n  .cm-note-dialog__sheet {\n    width: min(100%, 440px);\n    height: auto;\n    max-height: min(86vh, 680px);\n    border-radius: 22px;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.4);\n  }\n\n  .cm-note-dialog__grab {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-note-dialog,\n  .cm-note-dialog__sheet,\n  .cm-note-dialog__wave.is-live i {\n    animation: none;\n  }\n}\n\n.cm-page--light .cm-player-notes__card {\n  background:\n    linear-gradient(\n      165deg,\n      color-mix(in srgb, var(--cm-primary, #0877bc) 10%, transparent),\n      transparent 50%\n    ),\n    rgba(255, 255, 255, 0.92);\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);\n}\n\n.cm-page--light .cm-player-notes__card-meta strong,\n.cm-page--light .cm-player-notes__list p {\n  color: #0f172a;\n}\n\n.cm-page--light .cm-player-notes__list li {\n  background: rgba(255, 255, 255, 0.82);\n}\n\n.cm-page--light .cm-player-notes__empty {\n  color: #475569;\n}\n\n.cm-note-dialog.is-light {\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 18%, rgba(15, 23, 42, 0.28));\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__sheet {\n  background:\n    radial-gradient(\n      120% 80% at 10% 0%,\n      color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent),\n      transparent 58%\n    ),\n    var(--cm-note-surface, var(--cm-note-bg, #f8fafc));\n  color: var(--cm-note-text, #0f172a);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__kicker,\n.cm-note-dialog.is-light .cm-note-dialog__hint,\n.cm-note-dialog.is-light .cm-note-dialog__existing-head,\n.cm-note-dialog.is-light .cm-note-dialog__dictate {\n  color: var(--cm-note-muted, #475569);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__who h2,\n.cm-note-dialog.is-light .cm-note-dialog__player strong {\n  color: var(--cm-note-text, #0f172a);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__rating,\n.cm-note-dialog.is-light .cm-note-dialog__team,\n.cm-note-dialog.is-light .cm-note-dialog__vs {\n  color: var(--cm-note-muted, #475569);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__close,\n.cm-note-dialog.is-light .cm-note-dialog__media-play,\n.cm-note-dialog.is-light .cm-note-dialog__cancel,\n.cm-note-dialog.is-light .cm-note-dialog__pick {\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 10%, transparent);\n  color: var(--cm-note-text, #0f172a);\n  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__kinds button,\n.cm-note-dialog.is-light .cm-note-dialog__modes button {\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 7%, var(--cm-note-surface, #fff));\n  color: var(--cm-note-muted, #475569);\n  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 22%, transparent);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__kinds button.is-on,\n.cm-note-dialog.is-light .cm-note-dialog__modes button.is-on {\n  color: #fff;\n  background: var(--cm-note-primary, #0877bc);\n  border-color: var(--cm-note-primary, #0877bc);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__existing li {\n  background: var(--cm-note-surface, #fff);\n  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 18%, transparent);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__existing p {\n  color: var(--cm-note-text, #0f172a);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__body textarea {\n  background: var(--cm-note-surface, #fff);\n  color: var(--cm-note-text, #0f172a);\n  border-color: color-mix(in srgb, var(--cm-note-primary, #0877bc) 28%, transparent);\n}\n\n.cm-note-dialog.is-light .cm-note-dialog__grab {\n  background: color-mix(in srgb, var(--cm-note-primary, #0877bc) 35%, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
